import { render, staticRenderFns } from "./info-page.vue?vue&type=template&id=182dbeb0"
import script from "./info-page.vue?vue&type=script&lang=js"
export * from "./info-page.vue?vue&type=script&lang=js"
import style0 from "./info-page.vue?vue&type=style&index=0&id=182dbeb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports